<template>
  <div class="n_success">
    <span class="iconfont iconduihao1 n_succe"></span>
    <p class="n_text">支付成功</p>
    <div class="flex n_flex">
      <div class="n_btn n_index" @click="jump('home')">首页</div>
      <div class="n_btn n_order" @click="jump('myOrder')">订单列表</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  mounted() {
    this.prohibitweixinShare()
  },
  methods: {
    jump(e) {
      console.log(this.$route)
      console.log(this.$route.query)
      if (this.$route.query && this.$route.query.payInfo) {
        this.$router.push({ path: `./${e}` })
        return
      } else {
        let mchData = {
          action: 'jumpOut',
          jumpOutUrl: `https://${localStorage.getItem(
            'domain'
          )}/yj_project/#/${e}`,
        }
        let postData = JSON.stringify(mchData)
        parent.postMessage(postData, 'https://payapp.weixin.qq.com')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.n_succe {
  display: block;
  font-size: 150px;
  color: rgba(7, 193, 96, 1);
  text-align: center;
  margin-top: 40px;
}
.n_text {
  font-size: 32px;
  color: #333333;
  font-weight: 700;
  text-align: center;
  margin-top: 80px;
}
.n_flex {
  justify-content: space-around;
  margin-top: 120px;
}
.n_btn {
  padding: 20px 94px;
  font-size: 28px;
}
.n_index {
  background: #ffffff;
  border-radius: 200px;
  border: 2px solid #ff7428;
  color: rgba(255, 116, 40, 1);
}
.n_order {
  background: #ff7428;
  border-radius: 200px;
  color: rgba(255, 255, 255, 1);
}
</style>